import mapColors from './map-colors';
import { colorCollection } from './colors';
import { grayCollection } from './grays';
var allColorCollection = [].concat(colorCollection, grayCollection);
var allColors = mapColors(allColorCollection);
export default allColors;
export { allColorCollection };